import Vue from "vue";
import App from "./App.vue";

import router from "./router";

import "./plugins/axios";
import "./store/globalFunctions";
import "./store/globalVariables";
import "./store/enum";
import store from "./store/store";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import SimpleTimeline from "vue-simple-timeline";
import VueSweetalert2 from "vue-sweetalert2";
import moment from "vue-moment";
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import VueMask from "v-mask";
import Multiselect from "vue-multiselect";
import i18n from "./plugins/i18n/translations";
import AsyncComputed from "vue-async-computed";
import Toast, { TYPE } from "vue-toastification";
import "vue-toastification/dist/index.css";
import "../src/store/token.js";
import PrimeVue from "primevue/config";
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import VMasker from "vanilla-masker";

// TODO @rafael.silva AO DEV QUE PRECISAR DAR MANUTENÇÃO:
// -VÓS QUE ENTRAIS, ABANDONAI TODA A ESPERANÇA!
Vue.config.warnHandler = (msg, instance, trace) =>
	![
		"Avoid using non-primitive value as key, use string/number value instead",
		'Invalid handler for event "enterPress": got undefined'
	].some((warning) => msg.includes(warning)) && console.warn("[Vue warn]: ".concat(msg).concat(trace));

Vue.config.productionTip = false;
if (process.env.NODE_ENV != "development") {
	Vue.config.devtools = false;
}

Vue.use(VueSidebarMenu);
Vue.use(SimpleTimeline);
Vue.use(BootstrapVue);
Vue.use(AsyncComputed);
Vue.use(BootstrapVueIcons);
Vue.use(moment);
Vue.use(Multiselect);
Vue.use(PrimeVue);
Vue.use(Toast, {
	maxToasts: 1,
	icon: false,
	toastDefaults: {
		hideProgressBar: true,
		[TYPE.SUCCESS]: {
			position: "top-center",
			toastClassName: ["custom-toast", "success-toast"],
			timeout: 3000
		},
		[TYPE.INFO]: {
			position: "top-center",
			toastClassName: ["custom-toast", "info-toast"],
			timeout: 3000
		},
		[TYPE.WARNING]: {
			position: "top-center",
			closeOnClick: false,
			timeout: false,
			toastClassName: ["custom-toast", "warning-toast"],
			closeButtonClassName: ["custom-close-button", "custom-close-button-warning"]
		},
		[TYPE.ERROR]: {
			position: "top-center",
			timeout: false,
			closeOnClick: false,
			toastClassName: ["custom-toast", "error-toast"],
			closeButtonClassName: ["custom-close-button", "custom-close-button-error"]
		}
	}
});

const options = {
	confirmButtonColor: "#00648f",
	cancelButtonColor: "#6c757d"
};
Vue.use(VueSweetalert2, options);
Vue.use(VueMask);
window.VMasker = VMasker;

new Vue({
	router,
	i18n,
	store,
	render: (h) => h(App)
}).$mount("#app");
